const global = {
    baseUrl:'https://www.fuhua52.com/api',     //测试
}


export default global